//
import createReducer from '../../reducers/utils/createReducer';
import * as c from './types';
import usFallback from '../../utils/i18n/locales/us.json';
import esFallback from '../../utils/i18n/locales/es.json';
import ptFallback from '../../utils/i18n/locales/pt.json';
import { AnyTypeToFix } from '../../types/anytype';
import { getDefaultLocale } from '../../_clean-code/utils/i18n';

type I18nStateType = {
  source: string;
  locale: string;
  translations: {
    [key: string]: string[];
  };
  allIds: string[];
  isLoading: boolean;
  error: Error | null;
};

const SUPPORTED_LOCALES = ['us', 'es', 'pt'];

const getInitialLocale = () => {
  const stored = localStorage.getItem('i18n-locale');
  return stored && SUPPORTED_LOCALES.includes(stored)
    ? stored
    : getDefaultLocale();
};

const initialState: I18nStateType = {
  source: getDefaultLocale(),
  locale: getInitialLocale(),
  translations: {},
  allIds: SUPPORTED_LOCALES,
  isLoading: false,
  error: null
};

export default createReducer(initialState, {
  [c.GET_TRANSLATIONS_REQUEST]: (state: AnyTypeToFix) => ({
    ...state,
    error: null,
    isLoading: true
  }),

  [c.GET_TRANSLATIONS_SUCCESS]: (
    state: I18nStateType = initialState,
    { payload }: AnyTypeToFix
  ) => ({
    ...state,
    translations: payload,
    allIds: Object.keys(payload),
    isLoading: false
  }),

  [c.GET_TRANSLATIONS_ERROR]: (
    state: AnyTypeToFix,
    { payload }: AnyTypeToFix
  ) => ({
    ...state,
    translations: { us: usFallback, es: esFallback, pt: ptFallback },
    allIds: SUPPORTED_LOCALES,
    error: payload,
    isLoading: false
  }),

  [c.SET_TRANSLATION_LOCALE]: (
    state: AnyTypeToFix,
    { payload }: AnyTypeToFix
  ) => {
    return {
      ...state,
      locale: payload
    };
  }
});
